export enum OfferListOrderBy
{
    NewestFirst = 0,
    ClosestFirst = 1
}